import React from 'react';

const Dashboard = (props) => {

    const {dashboard} = props;

    console.log(dashboard);

    return (
        <div className="container">
            <h1>Welcome</h1>

            <br/>

            <div>
                <h2>Servers</h2>
                We have {dashboard.noOfServers} servers and {dashboard.noOfEnabledServers} of these are enabled for synchronisation.
            </div>

            <div>
                <h2>Customers</h2>
                There are {dashboard.noOfCustomers} customers registered in {dashboard.noOfCountriesInCustomers} countries.

            </div>

            <div>
                <h2>Users</h2>
                {dashboard.noOfUsers} users are registered in the system.
            </div>

        </div>
    )
};

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/dashboard/Dashboard.js